module.exports = __webpack_public_path__ + "static/media/rl_logos.5a3e0b55.png";